import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { UserWO } from 'src/app/models/administration/user-WO';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { UpdateData } from 'src/app/models/commos/update-data';
import { HistoricalWO } from 'src/app/models/maintenance/historicalWO';
import { WorkOrder } from 'src/app/models/maintenance/work-order';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UploadService } from 'src/app/services/upload.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  fileInputParams,
  FunctionsService,
  HttpService,
  LocalStorageService,
  MessageService,
} from 'brainloper-ui';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-close-order',
    templateUrl: './close-order.component.html',
    styleUrls: ['./close-order.component.scss'],
    standalone: false
})
export class CloseOrderComponent implements OnInit {
  @Output() response = new EventEmitter<WorkOrder>();
  @Input() orderId: number;

  private file = null;
  private file2 = null;
  private file3 = null;
  public bodyOrder: WorkOrder;
  public roleId: number | null = null
  public operatorId: number;
  public formEjecucionOT: UntypedFormGroup;
  public bodyUsuarios: UserWO[];
  
  public istraccarDevice: boolean = false;

  public buttonActive: boolean = false;
  public inventoryModule: boolean = false;

  public fileInput: fileInputParams = {
    typeFile: 'imagen',
    input: 'vista',
    label: 'foto',
    edit: true,
    style: {
      width: '100%',
      height: screen.width > 400 ? '300px' : '150px',
      border: '1px solid black',
    },
  };

  constructor(
    private message: MessageService,
    private http: HttpService,
    private notificationService: NotificationsService,
    private router: Router,
    private storage: LocalStorageService,
    private uploadService: UploadService,
    private formBuilder: UntypedFormBuilder,
    private functioEter: FunctionsService,
  ) {
    this.roleId = this.storage.get<number>('roleId');
    this.inventoryModule = this.storage.get<boolean>('inventory_module');
    this.formEjecucionOT = this.formBuilder.group({
      workOrderId: 0,
      finalCost: 0,
      finalTime: 0,
      observations: '',
      odometer: 0,
    });
  }

  async ngOnInit() {
    this.operatorId = environment.idRolOperator;
    this.init();
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando informacion');
    let res: Array<WorkOrder> = await this.http.getDataBody(
      `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}/${this.orderId}`,
      [{ id: 'withUserWo', value: 'true' }]
    );
    if (res) {
      this.bodyOrder = res[0];
      this.bodyOrder.executionDate = this.functioEter.dateIso(
        this.bodyOrder.executionDate
      );
      this.formEjecucionOT.get('workOrderId').setValue(this.bodyOrder.id);
      this.formEjecucionOT.get('finalCost').setValue(this.bodyOrder.cost);
      this.formEjecucionOT.get('finalTime').setValue(
        this.bodyOrder.estimatedTime
      );
      this.formEjecucionOT.get('odometer').setValue(
        this.bodyOrder.odometer
      );
      
      // Deshabilitar el campo odómetro si existe traccarDeviceId
      this.istraccarDevice = !!this.bodyOrder.traccarDeviceId;
      if (this.istraccarDevice) {
        this.formEjecucionOT.get('odometer').disable();
      }
      
      if (this.bodyOrder.userWO?.length > 0) {
        this.bodyUsuarios = this.bodyOrder.userWO;
      } else {
        this.bodyUsuarios = [{ name: 'No se tiene asociada información' }];
      }
    }
    this.message.closeLoading();
  }

  async ejecutarOT(form: HistoricalWO) {
    this.buttonActive = true;
    this.message.openLoading('Cargando', 'Cerrando Orden de trabajo');
    try {
      let res: Array<WorkOrder> = await this.http.getDataBody(
        `${EndpointDictionary.WorkOrder.CRUD_WORK_ORDER_DATA}/${this.orderId}`
      );
      if (res) {
        if (res[0].active == 1) {
          if (
            !this.istraccarDevice &&
            form.odometer <= res[0].currentOdometer &&
            this.roleId == this.operatorId
          ) {
            this.message.Warning(
              'Advertencia',
              'El valor del medidor debe ser mayor que ' +
                res[0].currentOdometer.toLocaleString()
            );
            this.buttonActive = false;
            this.message.closeLoading();
            return;
          }
          form.equipmentId = res[0].equipmentId;
          
          // Si el odómetro está deshabilitado, mantener el valor original
          if (this.istraccarDevice) {
            form.odometer = res[0].currentOdometer;
          }
          
          this.closeOT(form);
        } else {
          this.message.Warning(
            'Advertencia',
            'Esta orden ya fue cerrada por un operario'
          );
          this.deleteNotificationByUrl();
          this.message.closeLoading();
          setTimeout(() => {
            this.router.navigate(['/inicio']);
          }, 500);
        }
      }
    } catch (error) {
      this.message.Error('Error', 'No se pudo cerrar la orden.');
      console.error(error);
    }
  }

  errorMessage() {
    this.message.Error('Error', 'complete los campos');
  }

  async closeOT(form: HistoricalWO) {
    this.message.openLoading('Cargando', 'Cerrando orden de trabajo');
    form.photo1 = await this.uploadService.uploadFile(this.file);
    form.photo2 = await this.uploadService.uploadFile(this.file2);
    form.photo3 = await this.uploadService.uploadFile(this.file3);

    if (!form.finalCost || form.finalCost <= 0) {
      form.finalCost = this.bodyOrder.cost;
    }

    const resEjecucionOT: GenericResponse = await this.http.postDataBody(
      EndpointDictionary.WorkOrder.WORK_ORDER_CLOSE,
      form
    );

    if (resEjecucionOT) {
      this.deleteNotificationByUrl();
      this.message.closeLoading();
      this.message.SuccessToast(resEjecucionOT['message']);
      setTimeout(() => {
        this.router.navigate(['/inicio']);
      }, 500);
    }
    this.message.closeLoading();
  }

  fileSave($event: UpdateData<File>, i: number) {
    switch (i) {
      case 1:
        if ($event.compressor) {
          this.file = $event.compressor;
        } else {
          this.file = $event.new;
        }
        console.log(this.file);
        break;

      case 2:
        if ($event.compressor) {
          this.file2 = $event.compressor;
        } else {
          this.file2 = $event.new;
        }
        console.log(this.file2);
        break;

      case 3:
        if ($event.compressor) {
          this.file3 = $event.compressor;
        } else {
          this.file3 = $event.new;
        }
        console.log(this.file3);

        break;

      default:
        break;
    }
  }

  private deleteNotificationByUrl() {
    this.notificationService.deleteNotificationByUrl(
      `notificaciones/ejecucion?id_orden_trabajo=${this.orderId}`
    );
  }
}
